/**
 * @fileoverview PUT handler for the "/companies/:company_id/oauth_mcp_settings/marketplace_clients/:key" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdOauthMcpSettingsMarketplaceClientsKeyCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsKeyProps,
  PutCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsKeyResult,
} from "./types";

export const putCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsKey = reactQueryMutationAdapter(
  companiesCompanyIdOauthMcpSettingsMarketplaceClientsKeyCacheKeys,
  (
    props: PutCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsKeyProps
  ): Promise<PutCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsKeyResult> => {
    return fetch(
      `/companies/${props.company_id}/oauth_mcp_settings/marketplace_clients/${props.key}`,
      "PUT",
      { status: props.status, redirect_uris: props.redirect_uris },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
